// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as PenthouseRouteImport } from './routes/penthouse'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as ImplementationRouteImport } from './routes/implementation'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PricingIndexRouteImport } from './routes/pricing.index'
import { Route as AcademyIndexRouteImport } from './routes/academy.index'
import { Route as PricingTeamsRouteImport } from './routes/pricing.teams'
import { Route as PricingLandRouteImport } from './routes/pricing.land'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LegalRefundsRouteImport } from './routes/legal.refunds'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as AcademyCourseIndexRouteImport } from './routes/academy.$course.index'
import { Route as AcademyCourseLessonRouteImport } from './routes/academy.$course.$lesson'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app/index'
import { Route as AuthenticatedAppSellerRouteImport } from './routes/_authenticated/app/seller'
import { Route as AuthenticatedAppReportsRouteImport } from './routes/_authenticated/app/reports'
import { Route as AuthenticatedAppPipelineRouteImport } from './routes/_authenticated/app/pipeline'
import { Route as AuthenticatedAppLandRouteImport } from './routes/_authenticated/app/land'
import { Route as AuthenticatedAppIntelligenceRouteImport } from './routes/_authenticated/app/intelligence'
import { Route as AuthenticatedAppFollowUpRouteImport } from './routes/_authenticated/app/follow-up'
import { Route as AuthenticatedAppBuyersRouteImport } from './routes/_authenticated/app/buyers'
import { Route as AuthenticatedAppBillingRouteImport } from './routes/_authenticated/app/billing'
import { Route as AuthenticatedAppAnalyzeRouteImport } from './routes/_authenticated/app/analyze'

const PracticeRoute = PracticeRouteImport.update({
            id: '/practice',path: '/practice',getParentRoute: () => rootRouteImport
          })
const PenthouseRoute = PenthouseRouteImport.update({
            id: '/penthouse',path: '/penthouse',getParentRoute: () => rootRouteImport
          })
const OpsRoute = OpsRouteImport.update({
            id: '/ops',path: '/ops',getParentRoute: () => rootRouteImport
          })
const ImplementationRoute = ImplementationRouteImport.update({
            id: '/implementation',path: '/implementation',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PricingIndexRoute = PricingIndexRouteImport.update({
            id: '/pricing/',path: '/pricing/',getParentRoute: () => rootRouteImport
          })
const AcademyIndexRoute = AcademyIndexRouteImport.update({
            id: '/academy/',path: '/academy/',getParentRoute: () => rootRouteImport
          })
const PricingTeamsRoute = PricingTeamsRouteImport.update({
            id: '/pricing/teams',path: '/pricing/teams',getParentRoute: () => rootRouteImport
          })
const PricingLandRoute = PricingLandRouteImport.update({
            id: '/pricing/land',path: '/pricing/land',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalRefundsRoute = LegalRefundsRouteImport.update({
            id: '/legal/refunds',path: '/legal/refunds',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const AcademyCourseIndexRoute = AcademyCourseIndexRouteImport.update({
            id: '/academy/$course/',path: '/academy/$course/',getParentRoute: () => rootRouteImport
          })
const AcademyCourseLessonRoute = AcademyCourseLessonRouteImport.update({
            id: '/academy/$course/$lesson',path: '/academy/$course/$lesson',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppSellerRoute = AuthenticatedAppSellerRouteImport.update({
            id: '/app/seller',path: '/app/seller',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppReportsRoute = AuthenticatedAppReportsRouteImport.update({
            id: '/app/reports',path: '/app/reports',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppPipelineRoute = AuthenticatedAppPipelineRouteImport.update({
            id: '/app/pipeline',path: '/app/pipeline',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppLandRoute = AuthenticatedAppLandRouteImport.update({
            id: '/app/land',path: '/app/land',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppIntelligenceRoute = AuthenticatedAppIntelligenceRouteImport.update({
            id: '/app/intelligence',path: '/app/intelligence',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppFollowUpRoute = AuthenticatedAppFollowUpRouteImport.update({
            id: '/app/follow-up',path: '/app/follow-up',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppBuyersRoute = AuthenticatedAppBuyersRouteImport.update({
            id: '/app/buyers',path: '/app/buyers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppBillingRoute = AuthenticatedAppBillingRouteImport.update({
            id: '/app/billing',path: '/app/billing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppAnalyzeRoute = AuthenticatedAppAnalyzeRouteImport.update({
            id: '/app/analyze',path: '/app/analyze',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAppAnalyzeRoute: AuthenticatedAppAnalyzeRoute,AuthenticatedAppBillingRoute: AuthenticatedAppBillingRoute,AuthenticatedAppBuyersRoute: AuthenticatedAppBuyersRoute,AuthenticatedAppFollowUpRoute: AuthenticatedAppFollowUpRoute,AuthenticatedAppIntelligenceRoute: AuthenticatedAppIntelligenceRoute,AuthenticatedAppLandRoute: AuthenticatedAppLandRoute,AuthenticatedAppPipelineRoute: AuthenticatedAppPipelineRoute,AuthenticatedAppReportsRoute: AuthenticatedAppReportsRoute,AuthenticatedAppSellerRoute: AuthenticatedAppSellerRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,ImplementationRoute: ImplementationRoute,OpsRoute: OpsRoute,PenthouseRoute: PenthouseRoute,PracticeRoute: PracticeRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalRefundsRoute: LegalRefundsRoute,LegalTermsRoute: LegalTermsRoute,PricingLandRoute: PricingLandRoute,PricingTeamsRoute: PricingTeamsRoute,AcademyIndexRoute: AcademyIndexRoute,PricingIndexRoute: PricingIndexRoute,AcademyCourseLessonRoute: AcademyCourseLessonRoute,AcademyCourseIndexRoute: AcademyCourseIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)